import React, { useState, useRef, useEffect, useMemo } from "react";
import "./scss/multi-search-select.scss";

export default function MultiSearchSelect({
  label,
  value = [],
  onChange,
  options = [],
  className = ""
}) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  const isActive = open || value.length > 0;

  const selectedLabels = useMemo(() => {
    return options
      .filter(o => value.includes(o.value))
      .map(o => o.label)
      .join(", ");
  }, [value, options]);

  useEffect(() => {
    function handleClickOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  function toggleOption(optionValue) {
    let next;

    if (value.includes(optionValue)) {
      next = value.filter(v => v !== optionValue);
    } else {
      next = [...value, optionValue];
    }

    onChange?.(next);
  }

  function clear() {
    onChange?.([]);
  }

  return (
    <div
      className={`multi-search-select ${className} ${
        isActive ? "active" : ""
      }`}
      ref={wrapperRef}
    >
      <div
        className="multi-search-select__input-wrapper"
        onClick={() => setOpen(!open)}
      >
        <input
          value={selectedLabels}
          readOnly
        />

        <label>{label}</label>

        {value.length > 0 && (
          <button
            type="button"
            className="multi-search-select__clear"
            onClick={(e) => {
              e.stopPropagation();
              clear();
            }}
          >
            ×
          </button>
        )}

        <button
          type="button"
          className={`multi-search-select__arrow ${
            open ? "open" : ""
          }`}
        >
          ⌃
        </button>
      </div>

      {open && (
        <div className="multi-search-select__dropdown">
          {options.map(option => (
            <div
              key={option.value}
              className="multi-search-select__option"
              onClick={() => toggleOption(option.value)}
            >
              <input
                type="checkbox"
                checked={value.includes(option.value)}
                readOnly
              />
              <span>{option.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
